import type { AuthUser } from "../../shared/types.js";

export type AuthPhase = "checking" | "anonymous" | "authenticated";

export type ClientAuthState =
  | { phase: "checking" }
  | { phase: "anonymous" }
  | { phase: "authenticated"; user: AuthUser };

export function shouldMountWorkspace(state: ClientAuthState): boolean {
  return state.phase === "authenticated";
}

export function shouldSyncLibrary(state: ClientAuthState): boolean {
  return state.phase === "authenticated";
}

export function mapAuthApiError(error: string | undefined | null): string {
  switch (error) {
    case "invalid_email":
      return "Enter a valid email address.";
    case "turnstile_failed":
      return "Bot check failed. Try again.";
    case "rate_limited":
      return "Please wait before requesting another code.";
    case "email_unavailable":
      return "Could not send email right now. Try again shortly.";
    case "invalid_or_expired_code":
      return "That code is invalid or expired.";
    case "auth_unavailable":
    case "auth_not_configured":
    case "database_required":
      return "Sign-in is temporarily unavailable.";
    default:
      return "Something went wrong. Try again.";
  }
}

export function maskEmail(email: string): string {
  const [local, domain] = email.split("@");
  if (!local || !domain) return email;
  if (local.length <= 2) return `${local[0] ?? "*"}…@${domain}`;
  return `${local.slice(0, 2)}…@${domain}`;
}

export function isLocalDevHost(hostname: string = typeof window !== "undefined" ? window.location.hostname : ""): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]";
}
